import CloseButtonDialog from "App/components/CloseButtonDialog";
import React, { useState, useEffect, useContext, useLayoutEffect } from 'react';
import { LayoutContext } from 'App/Layout/store'
import { Grid, InputLabel, TextField, Paper, FormLabel, FormControl, Input, InputAdornment, IconButton, Divider } from "@material-ui/core";
import Axios from "axios";
import Typography from '@material-ui/core/Typography';
import { useAuth } from "react-oidc-context";
import Button from '@material-ui/core/Button';

function Index(props) {

    const layoutContext = useContext(LayoutContext);
    const [passA, setPassA] = useState("");
    const [pass, setPass] = useState("");
    const [pass2, setPass2] = useState("");
    const auth = useAuth();

    function GuardarContraseña() {
        var conf = window.confirm("¿Desea actualizar su contraseña?");
        if (conf) {
            Axios.post("/api/Cuenta/Clave/Guardar", { ClaveA:passA, Clave: pass })
                .then(r => alert(r))
                .catch(e => /*alert(e.response.data.Mensaje)*/{});
        }
    }
    const handleToggleModal = () => {
        layoutContext.dispatch({ type: "toggleModalUsuario" });
    }

    // const handleprueba = () => {
    //     prueba()
    // };
    const content = auth.isAuthenticated ? (
        <form>
            <Typography variant="h6">Datos Usuario</Typography>
            <Grid container spacing={0}>
                <Grid xs={6}><Typography style={{ margin: 8 }} >
                    <TextField
                        disabled
                        variant="outlined"
                        label="Nombre de Usuario"
                        fullWidth
                        value={auth.user.profile.preferred_username}
                        margin="normal"
                    />
                </Typography>
                </Grid>
                <Grid xs={6}><Typography style={{ margin: 8 }} >
                    <TextField
                        disabled
                        variant="outlined"
                        label="Nombre"
                        fullWidth
                        value={auth.user.profile.name}
                        margin="normal"
                    />
                </Typography>
                </Grid>
            </Grid>
            <Typography variant="h6">Cambio de Contraseña</Typography>
            <Grid container spacing={12}>
            <Grid xs={6}><Typography style={{ marginLeft: 8, marginRight: 8 }} >
                    <TextField
                        label="Contraseña Actual"
                        fullWidth
                        error={(pass != '' || pass2 != '') && !passA}
                        type="password"
                        variant="outlined"
                        value={passA}
                        onChange={e => setPassA(e.target.value)}
                        margin="normal"
                    />
                    {(pass || pass2) && !passA && <Typography style={{ color: "red" }}>Debe ingresar la contraseña actual</Typography>}
                </Typography>
                </Grid>
                <Grid item sm={6}></Grid>
                <Grid xs={6}><Typography style={{ marginLeft: 8, marginRight: 8 }} >
                    <TextField
                        label="Nueva Contraseña"
                        fullWidth
                        error={pass != pass2}
                        type="password"
                        variant="outlined"
                        value={pass}
                        onChange={e => setPass(e.target.value)}
                        margin="normal"
                    />
                </Typography>
                </Grid>
                <Grid xs={6}><Typography style={{ marginLeft: 8, marginRight: 8 }} >
                    <TextField
                        label="Confirmar Nueva Contraseña"
                        fullWidth
                        error={pass != pass2}
                        type="password"
                        variant="outlined"
                        value={pass2}
                        onChange={e => setPass2(e.target.value)}
                        margin="normal"
                    />
                    {pass != pass2 && <Typography style={{ color: "red" }}>Las dos contraseñas deben coincidir</Typography>}
                    </Typography>
                </Grid>
                <Typography style={{ margin: 8 }} >
                <Button disabled={!pass || pass != pass2} onClick={(e) => { e.preventDefault(); GuardarContraseña(); }} alignItems="center" variant="contained" size="large" color="primary">
                    Guardar
                </Button>
                </Typography>
            </Grid>
        </form>
    ) : null;
    return (
        <div>
            {auth.isAuthenticated ?
                <CloseButtonDialog open={layoutContext.state.openModalUsuario} onClose={handleToggleModal} closeButton title="Mi Cuenta" content={content} size="md" />
                : null}
        </div>
    );
}
export default React.memo(Index);
